import { useTranslation } from "react-i18next";
import { z } from "zod";

import {
  API_NAMESPACE_MAX_LENGTH,
  isValidApiNamespace,
} from "../utils/api-namespace";

const useDebugPanelSchema = () => {
  const { t } = useTranslation(["debug-panel"]);

  return z.object({
    // Empty means no namespace: the build's API.
    apiNamespace: z
      .string()
      .trim()
      .toLowerCase()
      .max(
        API_NAMESPACE_MAX_LENGTH,
        t("debug-panel:api-namespace-too-long", "At most {{max}} characters", {
          max: API_NAMESPACE_MAX_LENGTH,
        }),
      )
      .refine(
        (name) => name === "" || isValidApiNamespace(name),
        t(
          "debug-panel:api-namespace-invalid",
          "Use lowercase letters, digits and hyphens, with no hyphen at either end",
        ),
      ),
  });
};

export type DebugPanelFormValues = z.infer<
  ReturnType<typeof useDebugPanelSchema>
>;

export default useDebugPanelSchema;
